import Cookies from 'js-cookie'

const prefix = "SZLB-HAMS-Merchant-";

export function getCookies(key) {
    return Cookies.get(prefix + key)
}

export function setCookies(key, val) {
    return Cookies.set(prefix + key, val)
}

export function removeCookies(key) {
    return Cookies.remove(prefix + key)
}

export function getLocalStorage(key) {
    return localStorage.getItem(key);
}

export function setLocalStorage(key, val) {
    return localStorage.setItem(key, val);
}

export function removeLocalStorage(key) {
    return localStorage.removeItem(key);
}



// WEBPACK FOOTER //
// ./src/common/auth.js